"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g446",
    transform: "matrix(1.2480369,0,0,1,-0.34424093,0)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "g3722-4",
      transform: "matrix(0.55171954,0,0,0.83963046,11.252937,1.9181642)",
      strokeWidth: "2.63034677",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        id: "g4369",
        transform: "matrix(0.94535774,0,0,0.94535774,-0.77376505,0.71963324)",
        strokeWidth: "2.78238243",
        strokeMiterlimit: "4",
        strokeDasharray: "none",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          strokeWidth: "2.78238243",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          transform: "translate(-19.941736,0.08959265)",
          id: "g3722",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            strokeWidth: "2.78238243",
            strokeMiterlimit: "4",
            strokeDasharray: "none",
            id: "path389",
            d: "M 7.0434309,3 H 2.6446546 C 1.9505469,3 1.3878615,3.8954305 1.3878615,5 v 14 c 0,1.104569 0.5626855,2 1.2567931,2 h 4.3718975"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          strokeWidth: "2.78238249",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          id: "path389-9-8",
          d: "m -12.898306,3.0895927 h 4.3718971 c 0.694108,0 1.256793,0.895431 1.256793,2 v 2.2050632"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          strokeWidth: "2.78238249",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          id: "path389-9-8-4",
          d: "m -12.925185,21.089593 h 4.3718963 c 0.6941084,0 1.2567934,-0.895431 1.2567934,-2 v -2.144852"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "g7186",
      transform: "matrix(1.7892132,0,0,2.2330041,-22.530729,-14.221713)",
      strokeWidth: "0.89565444",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        strokeWidth: "0.89565444",
        strokeMiterlimit: "4",
        strokeDasharray: "none",
        id: "line5914",
        y2: "13.397092",
        x2: "18.110062",
        y1: "10.306173",
        x1: "18.110062"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        strokeWidth: "0.89565444",
        strokeMiterlimit: "4",
        strokeDasharray: "none",
        id: "line5916",
        y2: "11.851624",
        x2: "19.655523",
        y1: "11.851624",
        x1: "16.564611"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "g3722-4-6",
      transform: "matrix(-0.55171954,0,0,-0.83963046,8.6323832,22.45984)",
      strokeWidth: "2.63034677",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        id: "g4369-0",
        transform: "matrix(0.94535774,0,0,0.94535774,-0.77376505,0.71963324)",
        strokeWidth: "2.78238243",
        strokeMiterlimit: "4",
        strokeDasharray: "none",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          strokeWidth: "2.78238243",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          transform: "translate(-19.941736,0.08959265)",
          id: "g3722-45",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            strokeWidth: "2.78238243",
            strokeMiterlimit: "4",
            strokeDasharray: "none",
            id: "path389-3",
            d: "M 7.0434309,3 H 2.6446546 C 1.9505469,3 1.3878615,3.8954305 1.3878615,5 v 14 c 0,1.104569 0.5626855,2 1.2567931,2 h 4.3718975"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          strokeWidth: "2.78238243",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          id: "path389-9-8-1",
          d: "m -12.898306,3.0895927 h 4.3718971 c 0.694108,0 1.256793,0.895431 1.256793,2 v 1.9010475"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          strokeWidth: "2.78238243",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          id: "path389-9-8-4-0",
          d: "m -12.925185,21.089593 h 4.3718963 c 0.6941084,0 1.2567934,-0.895431 1.2567934,-2 v -1.943187"
        })]
      })
    })]
  })
}));